import { useModalContext } from 'utils/contexts/modal';

import { AddAccountModal } from './AddAccountModal';
import { DeleteAccountModal } from './DeleteAccountModal';
import { MovableInkModal } from '../constants';
import { MovableInkModalState } from '../types';

export const MovableInkIntegrationModals = () => {
  const { modalState } = useModalContext<MovableInkModalState>();

  switch (modalState?.modalId) {
    case MovableInkModal.Add:
      return <AddAccountModal />;
    case MovableInkModal.Delete:
      return <DeleteAccountModal />;
    default:
      return null;
  }
};
